<script lang="ts">
    import Header from "./Header/Header.svelte"; 
    import Footer from "./Footer/Footer.svelte";
    import Sidebar from "./Sidebar/Sidebar.svelte";
    import ThemeCustomizer from "./Themecustomizer/ThemeCustomizer.svelte";
    import { tablist,layoutClass,sidebarClass,horizontalSidebar,pageBodyClass } from "../store";
    import { onMount } from "svelte";
    import PreLodaer from "./PreLoader/PreLodaer.svelte";
    import Tabcustomizer from "./Themecustomizer/Tabcustomizer.svelte";
    
    let setTabList:boolean
    let ispreloader:boolean = false;
    tablist.subscribe((value)=>{
        setTabList = value
    })
    let setLayoutClass:string
    layoutClass.subscribe((value)=> {
        setLayoutClass = value
    })
    let setSidebarClass:string
    sidebarClass.subscribe((value)=>{
        setSidebarClass = value
    })
    let setHorizontalSidebar
    horizontalSidebar.subscribe((value)=>{
        setHorizontalSidebar = value
    })
    onMount(()=>{
        setTimeout(()=>{
            ispreloader = true;
        },1000)  
    })
    let setPageBodyClass
    pageBodyClass.subscribe((value)=> {
        setPageBodyClass = value
    })
    let y:number
    $: if(y < 992){
        sidebarClass.update((value)=> value = "compact-wrapper")
    }else{
        sidebarClass.update((value)=> value = setHorizontalSidebar)
    }
</script>
<svelte:window bind:innerWidth={y} />
{#if !ispreloader }
  <PreLodaer/>
{/if}
<div class="page-wrapper {setSidebarClass} {setLayoutClass}" id="pageWrapper">
    <Header />
    <div class="page-body-wrapper horizontal-menu">
        <Sidebar />
        <div class="page-body {setPageBodyClass ? "dashboard-2-main" : ""}">
            <slot/>
        </div>
        <Footer />
    </div>
    <div class={`customizer-links ${setTabList ? "open" : ""}`}  >
        <ThemeCustomizer/>
        <div class={`customizer-contain ${setTabList ? 'open' : ''}`}>
            <Tabcustomizer/>
        </div>
    </div>
</div>

   